/** Metodi di pagamento del checkout (`backend/orders/pagamenti.py`). Quali
 *  può usare il Cliente lo dice il backend in `pagamentiAmmessi`: la sua
 *  condizione NTS (`condizioni`, se non coincide con un altro metodo),
 *  contrassegno e bonifico all'ordine (chiave storica `bonifico_anticipato`). */
export type MetodoPagamento = 'condizioni' | 'bonifico_anticipato' | 'contrassegno' | 'carta';

/** `idCondizionePagamento` dell'ordine. */
export const ID_PAGAMENTO: Record<MetodoPagamento, number> = {
  bonifico_anticipato: 1,
  carta: 2,
  condizioni: 3,
  contrassegno: 5,
};

/** Senza risposta dal backend: contrassegno e bonifico all'ordine. La carta è
 *  disattivata per ora (`CARTA_ATTIVA` in `backend/orders/pagamenti.py`): per
 *  riattivarla, rimetterla anche qui in coda. */
export const PAGAMENTI_IMMEDIATI: MetodoPagamento[] = ['contrassegno', 'bonifico_anticipato'];

/** Etichetta e descrizione; `condizione` è la condizione NTS del Cliente,
 *  `ritiro` la consegna in sede (il contrassegno non passa dal corriere):
 *  senza, come nelle Preferenze, il contrassegno resta generico. */
export function descriviPagamento(
  metodo: MetodoPagamento,
  { condizione, ritiro }: { condizione?: string | null; ritiro?: boolean } = {},
): { label: string; descrizione: string } {
  switch (metodo) {
    case 'condizioni':
      // La condizione NTS stessa ("RICEVUTA BANCARIA 30 GG D.F.F.M."); il
      // nome generico solo se l'anagrafica non ce l'ha.
      return { label: condizione || 'Condizioni concordate', descrizione: 'Come da accordi in essere' };
    case 'bonifico_anticipato':
      return { label: "Bonifico all'ordine", descrizione: "Bonifico bancario anticipato" };
    case 'contrassegno':
      if (ritiro === undefined) return { label: 'Contrassegno', descrizione: 'Pagamento alla consegna o al ritiro' };
      return ritiro
        ? { label: 'Contrassegno', descrizione: 'Pagamento al ritiro in sede' }
        : { label: 'Contrassegno vettore', descrizione: 'Pagamento direttamente al corriere alla consegna — +3,00€ spese' };
    case 'carta':
      return { label: 'Carta di Credito / Debito', descrizione: 'Pagamento sicuro. Nessun costo aggiuntivo.' };
  }
}
